export const caseFieldHandlers = {
  firstCase: (obj) => ({
    earnedBasic: obj?.earnedBasic,
    earnedPeraAda: obj?.earnedPeraAda,
    tax: obj?.tax,
    overpaymentBasic: obj?.overpaymentBasic ?? 0,
    overpaymentPeraAda: obj?.overpaymentPeraAda ?? 0,
  }),

  secondCase: (obj) => ({
    daysToBeDeducted: obj?.daysToBeDeducted,
    halfDaysToBeDeducted: obj?.halfDaysToBeDeducted,
    minutesToBeDeducted: obj?.minutesToBeDeducted,
    gsisInsuredDays: obj?.gsisInsuredDays,
    deductionsDueToLeavesAbsencesAndTardinessBasic:
      obj?.deductionDueToLeavesTardy,
    deductionPeraAda: obj?.deductionPeraAda,
    overpaymentBasic: obj?.overpaymentBasic ?? 0,
    overpaymentPeraAda: obj?.overpaymentPeraAda ?? 0,
    earnedBasic: obj?.earnedBasic ?? 0,
    earnedPeraAda: obj?.earnedPeraAda ?? 0,
    tax: obj?.tax,
  }),

  thirdCase: (obj) => ({
    daysInAMonth: obj.daysInAMonth,
    gsisInsuredDays: obj.gsisInsuredDays,
    daysToBeDeducted: obj.daysToBeDeducted,
    halfDaysToBeDeducted: obj.halfDaysToBeDeducted,
    minutesToBeDeducted: obj.minutesToBeDeducted,
    basicRateForBackPay: obj.basicRateForBackPay,
    peraAdaForBackPay: obj.peraAdaForBackPay,
    deductionDueToLeavesLeavesAbsencesAndTardinessBasic:
      obj.deductionDueToLeavesTardy,
    deductionPeraAda: obj.deductionPeraAda,
    overpaymentBasic: obj.overpaymentBasic,
    overpaymentPeraAda: obj.overpaymentPeraAda,
    earnedBasic: obj.earnedBasic,
    earnedPeraAda: obj.earnedPeraAda,
    tax: obj.tax,
    netPay: obj.netAmount,
  }),

  fourthCase: (obj) => ({
    year: obj.year,
    month: obj.month,
    daysToBeDeducted: obj.daysToBeDeducted,
    minsToBeDeducted: obj.minutesToBeDeducted,
    noOfDays: obj.noOfDays,
    absencesDays: obj.absencesDays,
    absencesMins: obj.absencesMins,
    overpayment: obj.overpayment,
    flagRaising: obj.flagRaising,
    earnedForThePeriod: obj.earnedForThePeriod,
    3: obj.threePercent,
    2: obj.twoPercent,
    5: obj.fivePercent,
    10: obj.tenPercent,
    totalTax: obj.totalTax,
    netAmount: obj.netAmount,
  }),

  sixthCase: (obj) => ({
    year: obj.year,
    month: obj.month,
    y247N700530: obj.assignedArea,
    abs: obj.absencesPresent,
    abs2: obj.absencesAugmentation,
    OfDutyForCiaMciaBinocRangeTo1519: obj.dutyForCiaMciaBinoc,
    latesUt: obj.latesUTMinsPresent,
    noOfDuties: obj.noOfDuties,
    latesUt2: obj.latesUTMinsAirport,
    apRate: obj.payCode,
    totalDaysDuty: obj.totalDaysDuty,
    proratedApRate: obj.proratedApRate,
    latesUt3: obj.latesUTMinsCurrent,
    earnedCurrentAssignment: obj.earnedCurrAssignment,
    airportAugmentationRate: obj.airportAugRate,
    latesUt4: obj.latesUTMinsAirportAug,
    earnedAirportDuties: obj.earnedAirportDuties,
    excessAirportDuties: obj.excessAirportDuty,
    totalEarned: obj.totalEarned,
    overpayment: obj.overpayment,
    flagRaising: obj.flagRaising,
    netEarned: obj.netEarned,
    tax: obj.tax,
    netAmount: obj.netAmount,
  }),

  seventhCase: (obj) => ({
    gross: obj.gross,
    peraAda: obj.peraAda,
    inService: obj.inService,
    proratedRate: obj.proratedRate,
    proratedPera: obj.proratedPera,
    mins: obj.minsDeduction,
    mins2: obj.minsBasic,
    mins3: obj.minsPera,
    daysForGsis: obj.daysForGsis,
    basicEarned: obj.basicEarned,
    peraAdaEarned: obj.peraAdaEarned,
    total: obj.totalforBasicPera,
    tax: obj.taxIP,
    netPay: obj.netAmount,
  }),
  eightCase: (obj) => ({
    y247N700530: obj.assignedArea,
    OfDutyForCiaMciaBinocRangeTo1519: obj.dutyForCiaMciaBinoc,
    apRate: obj.apRateArray,
    plantillaItems: obj.position,
    dailyRate: obj.dailyRate,
    perMinute: obj.perMinuteAP,
    overpayment: obj.overpayment,
    flagRaising: obj.flagRaising,
    daysEarned: obj.daysEarned,
    noOfLatesIncurred: obj.noOfLatesIncurred,
    latesUtDeduction: obj.latesUtDeduction,
    earnedForThePeriod: obj.earnedForThePeriod,
    tax: obj.tax,
    netPay: obj.netAmount,
  }),
  ninthCase: (obj) => ({
    representationAllowanceTransportationAllowanceRata: obj.rataAllowance,
    numberOfWorkdaysOfActualWorkPerformanceInAMonth: obj.actualWorkPerformance,
    actualRataForAMonth: obj.actualRataForAMonth,
    netAmount: obj.netAmount,
  }),
  tenthCase: (obj) => ({
    totalAmtEarned: obj.totalAmtEarned,
    gsis: obj.gsis,
    philhealth: obj.philhealth,
    myDiff: obj.myDiff,
    yeDiff: obj.yeDiff,
    netPay: obj.netAmount,
  }),
  eleventhCase: (obj) => ({
    perDay: obj.perDay,
    perMinute: obj.perMinute,
    absDays: obj.absencesDays,
    absMins: obj.absencesMins,
    noOfDaysPresent: obj.noOfDaysPresent,
    earned: obj.earned,
    20: obj.twentyPercent,
    totalEarned: obj.totalEarned,
    whTax3: obj.threePercent,
    2: obj.twoPercent,
    netAmount: obj.netAmount,
  }),
  twelveCase: (obj) => ({
    earnedForThePeriod: obj.earnedForThePeriodFrom,
    earnedForThePeriod2: obj.earnedForThePeriodTo,
    totalEarned: obj.totalEarned,
    year: obj.year,
    "20EarnedAmount": obj.twentyPercentEarned,
    3: obj.threePercent,
    netPay: obj.netAmount,
  }),
};
